export default __webpack_public_path__ + "static/media/upload.0f21c826.jpg";